import { Locale } from 'modules/i18n';

export const codeExampleButtonTranslation = {
  [Locale.en]: {
    codeExample: 'Code example',
  },
};
